module.exports = __webpack_public_path__ + "img/icon-search-1.580052ab.svg";